import { BlendMode } from '@website-builder/model/style/blend-mode';
import { TbLink } from '@website-builder/model/domain/link/tb-link';
import { makeEntityId } from '@website-builder/util/make-widget-id.utility';
import { EntityIdPrefix } from '@website-builder/model/domain/entity-id-prefix.enum';

export class SliderElement {
  id = makeEntityId(EntityIdPrefix.WIDGET_ELEMENT);
  title = '';
  subtitle = '';
  content = '';
  src: string;
  blendMode: BlendMode;
  buttonText: string;
  link = new TbLink();

  constructor(src?: string) {
    this.src = src;
  }

  static normalizeInPlace(element: SliderElement): SliderElement {
    const pureElement = new SliderElement();

    element.title = element.title ?? pureElement.title;
    element.subtitle = element.subtitle ?? pureElement.subtitle;
    element.content = element.content ?? pureElement.content;
    element.src = element.src ?? pureElement.src;
    element.blendMode = element.blendMode ?? pureElement.blendMode;
    element.buttonText = element.buttonText ?? pureElement.buttonText;
    element.link = TbLink.normalizeInPlace(element.link ?? pureElement.link);

    return element;
  }
}
